(function () {
    'use strict';

    angular
        .module('app.shared')
        .constant('transfersResolver', {
            filter: create('filter'),
            transfers: create('transfers'),
            managementGroups: create('managementGroups'),
            isClubAdminPage: create('isClubAdminPage')
        });

    var extend = angular.extend;

    function create(name) {
        resolve.$inject = ['$q', '$transition$', 'Club', 'defaultTransferListPageSize', 'clubMembershipTransferStatusType', 'clubAdminStateName'];
        return resolve;

        function resolve($q, $transition$, Club, defaultTransferListPageSize, transferStatus, clubAdminStateName) {
            if (!$transition$.resolvePromise) {
                $transition$.resolvePromise = $q.resolve({})
                    .then(getIsClubAdminPage)
                    .then(getClubId)
                    .then(getManagementGroups)
                    .then(getClubManagementGroup)
                    .then(getFilter)
                    .then(getTransfers);
            }
            return $transition$.resolvePromise.then(pluck(name));

            function getIsClubAdminPage(result) {
                var state = $transition$.$to(),
                    isClubAdminPage = state.data && state.data.requireAdmin && state.includes[clubAdminStateName];
                return extend(result, { isClubAdminPage: isClubAdminPage });
            }
            function getClubId(result) {
                return result.isClubAdminPage ? extend(result, { clubId: $transition$.params().clubId }) : result;
            }
            function getManagementGroups(result) {
                return !result.isClubAdminPage ? Club.getManagementGroups().$promise.then(append.bind(result, 'managementGroups')) : result;
            }
            function getClubManagementGroup(result) {
                var managementGroup = result.managementGroups && result.managementGroups[0];
                return !result.isClubAdminPage ? extend(result, { managementGroupId: managementGroup && managementGroup.id }) : result;
            }
            function getFilter(result) {
                var filter = { clubId: result.clubId, clubManagementGroupId: result.managementGroupId, status: transferStatus.Pending };
                return extend(result, { filter: filter });
            }
            function getTransfers(result) {
                var params = { $filter: result.filter, $orderby: null, $skip: 0, $top: defaultTransferListPageSize };
                return Club.getTransferList(params).$promise.then(append.bind(result, 'transfers'));
            }

            function pluck(name) {
                return function (data) { return data[name]; }
            }

            function append(name, value) {
                return (this[name] = value) && this || this;
            }
        }
    }
})();